import React from "react";
import "./organization-detail-hero.scss";

import { GSInfoGroup, GSImage, GSButton } from "golfstatus_react_components";

import { faCog } from "@fortawesome/free-solid-svg-icons";

const OrganizationDetailHero = (props) => {
  const { organization, editClicked } = props;
  const getType = () => {
    return organization?.organizationType !== "unknown"
      ? organization?.organizationType?.replace?.("_", " ")
      : "Default Organization";
  };
  const getHeroLayout = (organization) => {
    let item = [
      {
        fit: "stretch",
        sections: [
          {
            sectionItems: [
              {
                type: "primary no-wrap",
                value: <GSImage size="medium wide" src={organization?.logo} />,
              },
            ],
          },
          {
            sectionItems: [
              { type: "primary no-wrap", value: organization?.name },
              {
                type: "secondary no-wrap capitalize",
                value: getType(),
              },
            ],
          },
        ],
      },
      {
        title: <GSButton buttonIcon={faCog} onClick={editButtonClicked} />,
      },
    ];
    return item;
  };
  const editButtonClicked = (e) => {
    editClicked?.();
  };
  return (
    <organization-detail-hero>
      <GSInfoGroup dataGroups={getHeroLayout(organization)} />
    </organization-detail-hero>
  );
};

export default OrganizationDetailHero;
